// Stores
import { useWindowStore } from '@/stores/window';

let GLOBAL_WINDOW_STORE = ref(null);

export const initializeWindowEvents = () => {
    if (process.server) return;

    // Instantiate store
    GLOBAL_WINDOW_STORE = useWindowStore();

    // Lifecycle Logic
    onMounted(() => {
        handleWindowResize();
        window.addEventListener('resize', handleWindowResize);
        window.addEventListener('scroll', handleWindowScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleWindowResize);
        window.removeEventListener('scroll', handleWindowScroll);
    });
};

const handleWindowScroll = () => {
    if (process.server) return;
    if (!GLOBAL_WINDOW_STORE) return;
    GLOBAL_WINDOW_STORE.updateScrollY(window.scrollY);
};

const handleWindowResize = () => {
    if (process.server) return;
    if (!GLOBAL_WINDOW_STORE) return;
    const widthChanged = GLOBAL_WINDOW_STORE.innerWidth !== window.innerWidth
    // Update window store Height && Width
    GLOBAL_WINDOW_STORE.updateWidth(window.innerWidth);
    GLOBAL_WINDOW_STORE.updateHeight(window.innerHeight);
    // Update window store deviceIs
    GLOBAL_WINDOW_STORE.updateDeviceIs();
    // Keep --vh custom property up to date
    if (process.client && widthChanged) document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
};
